module.exports = __webpack_public_path__ + "img/what-flow-01.dac06e28.svg";